var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"subtitle-2 red--text text-center"},[_vm._v(" "+_vm._s(_vm.$t('components.discountMsgComponent', { discount: _vm.showDiscountInPercentage }))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }